export const useIsReversedCompareColumns = () => {
  //TODO: remove after server changes
  const reversedCompareColumns = [
    'CPI',
    'CPD',
    'CpdD7',
    'CpD7R',
    'CpdD30',
    'CPD30R',
    'CPC',
    'RemarketingCPI',
    'TotalCpi',
    'TotalCpd',
  ];

  return name => reversedCompareColumns.includes(name);
};
